import { MatchSet } from "model/Match/Set/MatchSet";
import { TimeAttackTrackTimes } from "./TimeAttack/TimeAttackTrackTimes";
import { WorldTourSetTimes } from "./WorldTour/WorldTourSetTimes";
import { checkTypeExhausted } from "Utility";
import { MatchTeams } from "model/Match/MatchTeams";
import { RoundBasedTrackTimes } from "./RoundBased/RoundBasedTrackTimes";
import { MatchTrack } from "model/Match/Track/MatchTrack";

interface Props {
  set: MatchSet;
  teams: MatchTeams;
  tournamentId: string;
}
export const TrackTimes = ({ set, teams, tournamentId }: Props) => {
  if ((set.tracks as MatchTrack[]).every((t) => t.rounds.length === 0)) {
    return <></>;
  }

  switch (set.type) {
    case "ForwardCupMode":
    case "ForwardCupModeLong":
    case "Knockout":
    case "ReverseCupMode":
    case "Rounds":
    case "RoundsKnockout":
      return (
        <RoundBasedTrackTimes
          set={set}
          teams={teams}
          tournamentId={tournamentId}
        />
      );
    case "TimeAttack":
      return (
        <TimeAttackTrackTimes tracks={set.tracks} tournamentId={tournamentId} />
      );
    case "Matchmaking":
    case "WorldTour":
      return (
        <WorldTourSetTimes
          tracks={set.tracks}
          teams={teams}
          tournamentId={tournamentId}
        />
      );
    default:
      return checkTypeExhausted(set);
  }
};
